/**
 * Created by Mikhail Menshenin on 15.07.2024
 */

cleverapps.Environment.SCENE_VILLAGE_ATTACK = "village_attack";
